import search from "vendor/tweakwise/autocomplete";
import Menu from "components/menu/menu";
import NewsletterSubscribe from "helpers/newsletter-subscribe/footer";
import { appController as CompareWidget } from "components/compare-widget/compareWidget";
import { init as GtmInit } from "vendor/google/gtm/gtmEventTracker";
import { showModal } from "components/modal/modal";
import buttonLoader from "helpers/forms/button-loader/button-loader";
import { locationSitePopupInit } from "components/location-site-popup/locationSitePopup";
import { LiveFormatter } from "helpers/forms/live-format/live-format";
import { CountDown } from "components/countdown/countdown";
import LazySizesConfig from "helpers/lazysizes-config";
import { initCollapse } from "components/collapse/collapse";
import { showSingleAlert } from "components/alert/alert";
import { GtmEnhancedEcommerce } from "vendor/google/gtm/gtmEnhancedEcommerce";
import AffiliateDeduplicate from "helpers/affiliate-deduplicate/index";
import { CmsSchemaData } from "components/cms/schemadata";
import { recommendationsPopup } from "components/recommendations-popup/recommendationsPopup.js";
import { PhoneInputHelper } from "helpers/forms/phone-input/phone-input.js";

// AB tests
import { ab151 } from "../../abtests/ab-151.js";
import { ab180 } from "../../abtests/ab-180/ab-180";

// Suppress eslint warning, Fancybox IS being used

import { Fancybox } from "@fancyapps/ui";

export default () => {
  AffiliateDeduplicate();
  GtmInit();
  LazySizesConfig();
  search.init();
  NewsletterSubscribe();
  CompareWidget.init();
  Menu().init();
  showModal.init();
  buttonLoader.init();
  locationSitePopupInit();
  LiveFormatter.init();
  initCollapse("collapse__header");
  showSingleAlert();
  GtmEnhancedEcommerce.init();
  CmsSchemaData.init();
  recommendationsPopup.init();
  PhoneInputHelper.init();

  // AB-test
  ab151.init();
  ab180.init();

  // Generate countDowns
  const actionCounter = new CountDown();
  actionCounter.init("#action-counter");
  const topBannerCounter = new CountDown();
  topBannerCounter.init("#topbanner-counter");
};

// Binding fancybox to initialize
Fancybox.bind("[data-fancybox]", {
  // if we need to change option for a specific fancybox, copy this code and add the data attribute name
  Thumbs: {
    // Enable classic thumbnail display
    type: "classic",
  },
});
